import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postUploadUserDocument } from '@arrived/api_v2';
import { UserDocument, UserDocumentUploadRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { userDocumentsKeyFn } from './userDocuments.keys';

export function usePostUserDocumentMutation(options?: UseMutationOptions<UserDocument, UserDocumentUploadRequest>) {
  const queryClient = useQueryClient();

  return useMutation((request) => postUploadUserDocument(request), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(userDocumentsKeyFn(data.userId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
